(() => {
  if (window.divaSilverArticleCommerceTracking) return;
  window.divaSilverArticleCommerceTracking = true;

  document.addEventListener('click', (event) => {
    const control = event.target.closest(
      '[data-article-commerce-link], [data-article-commerce-item] a, [data-article-commerce-item] button, [data-article-commerce-collection]'
    );

    if (!control) return;

    const module = control.closest('[data-article-commerce]');
    const item = control.closest('[data-article-commerce-item]');
    const params = {
      article_handle: module?.dataset.articleHandle || control.dataset.articleHandle || '',
      destination_type: item ? 'product' : control.dataset.destinationType || 'collection',
      destination_handle: item?.dataset.productHandle || control.dataset.destinationHandle || '',
      link_text: control.textContent.trim().slice(0, 100)
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'article_commerce_click', params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'article_commerce_click', ...params });
    }
  });
})();
